import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52c2b3e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-layer" }
const _hoisted_2 = {
  key: 0,
  class: "mask"
}

import Ad from './Ad.vue'
import { closeDialog, RootState } from '@/store';
import { computed } from 'vue';
import { useStore } from 'vuex';
import Login from './Login.vue';
import CommentWriter from './CommentWriter.vue';
import BibleVersionSetting from './BibleVersionSetting.vue';
import ImageCode from './ImageCode.vue'
import Forget from './Forget.vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<RootState>(() => store.state)
function onClose(name: string) {
    closeDialog(store, name)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(data).dialogs.count > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_unref(data).dialogs.login)
      ? (_openBlock(), _createBlock(Login, {
          key: 1,
          options: _unref(data).dialogs.login,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (onClose('login')))
        }, null, 8, ["options"]))
      : _createCommentVNode("", true),
    (_unref(data).dialogs.forget)
      ? (_openBlock(), _createBlock(Forget, {
          key: 2,
          options: _unref(data).dialogs.forget,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (onClose('forget')))
        }, null, 8, ["options"]))
      : _createCommentVNode("", true),
    (_unref(data).dialogs.comments)
      ? (_openBlock(), _createBlock(CommentWriter, {
          key: 3,
          options: _unref(data).dialogs.comments,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (onClose('comments')))
        }, null, 8, ["options"]))
      : _createCommentVNode("", true),
    (_unref(data).dialogs.bibleSetting)
      ? (_openBlock(), _createBlock(BibleVersionSetting, {
          key: 4,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (onClose('bibleSetting')))
        }))
      : _createCommentVNode("", true),
    (_unref(data).dialogs.imgCode)
      ? (_openBlock(), _createBlock(ImageCode, {
          key: 5,
          options: _unref(data).dialogs.imgCode,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (onClose('imgCode')))
        }, null, 8, ["options"]))
      : _createCommentVNode("", true),
    (_unref(data).dialogs.ad)
      ? (_openBlock(), _createBlock(Ad, {
          key: 6,
          options: _unref(data).dialogs.ad,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (onClose('ad')))
        }, null, 8, ["options"]))
      : _createCommentVNode("", true)
  ]))
}
}

})